module.exports = __webpack_public_path__ + "assets/img/Profiting_002.cefebb60.svg";